<template>
    <div class="cont-result-faq margin-general">
        <NuxtLink :to="localPath('/faq')" class="back-link">
            <span data-v-b04161ba="" class="material-symbols-outlined" translate="no">chevron_left</span>
            {{ $t("faq.goback") }}
        </NuxtLink>
        <div class="sub-cont">
            <FaqAccordion>
                <div class="accordeon container movil">
                    <div class="content-main-tab">
                        <div class="tab-content ">
                            <div class="contet-general">
                                <h4 role="heading" aria-level="1">{{ $t("faq.tab13.title1") }}</h4>
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <!-- <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab13.text1") }}</span></p>
                                    </div> -->
                                    </div>
                                </div>
                                <!-- <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/metatrader4.svg" alt="Metatrader 4" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text2', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div> -->
                                <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/metatrader5.svg" alt="Metatrader 5" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text3', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <!-- <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/ctrader.svg" alt="cTrader" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text4', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/takion.svg" alt="Takion" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text5', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/lightspeed.svg" alt="Lightspeed" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text6', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/sterling.svg" alt="Sterling" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text7', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/das.svg" alt="DAS" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text8', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div>
                                <div class="icon-text">
                                    <div class="cont-icon opc-pad">
                                    <div class="list-image"><img src="/images/faq/cqg.svg" alt="CQG" class="responsive-image"></div>
                                    </div>
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4">
                                        <span v-html="formatContent('faq.tab13.text9', $t, localPath)"></span>
                                        </p>
                                    </div>
                                    </div>
                                </div> -->
                                <div class="icon-text">
                                    <div class="cont-general">
                                    <div class="sub-cont">
                                        <p class="body-4"><span >{{ $t("faq.tab13.text10") }}</span></p>
                                        <div class="buttons sub-cont"><a target="_blank" :href="getExternalUrl('/register/1/live-account')"  rel="noopener noreferrer"><button class="primary-button-medium">{{ $t("faq.tab13.btn") }}</button></a></div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FaqAccordion>
            <div class="accordeon container destock">
                <div class="content-main-tab ">
                    <div class="tab-content">
                        <div class="contet-general">
                            <h1>{{ $t("faq.tab13.title1") }}</h1>
                            <div class="icon-text">
                                <div class="cont-general">
                                <!-- <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab13.text1") }}</span></p>
                                </div> -->
                                </div>
                            </div>
                            <!-- <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/metatrader4.svg" alt="Metatrader 4" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text2', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div> -->
                            <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/metatrader5.svg" alt="Metatrader 5" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text3', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div>
                           <!--  <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/ctrader.svg" alt="cTrader" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text4', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/takion.svg" alt="Takion" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text5', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/lightspeed.svg" alt="Lightspeed" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text6', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/sterling.svg" alt="Sterling" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text7', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/das.svg" alt="DAS" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text8', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div>
                            <div class="icon-text">
                                <div class="cont-icon opc-pad">
                                <div class="list-image"><img src="/images/faq/cqg.svg" alt="CQG" class="responsive-image"></div>
                                </div>
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4">
                                      <span v-html="formatContent('faq.tab13.text9', $t, localPath)"></span>
                                    </p>
                                </div>
                                </div>
                            </div> -->
                            <div class="icon-text">
                                <div class="cont-general">
                                <div class="sub-cont">
                                    <p class="body-4"><span >{{ $t("faq.tab13.text10") }}</span></p>
                                    <div class="buttons sub-cont"><a target="_blank" :href="getExternalUrl('/register/1/live-account')"  rel="noopener noreferrer"><button class="primary-button-medium">{{ $t("faq.tab13.btn") }}</button></a></div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> 
</template>

<script setup>
import FaqAccordion from '~/components/faq/FaqAccordion.vue'
import { useExternalUrl } from '@/composables/useExternalUrl';
const { getExternalUrl } = useExternalUrl();

const { t } = useI18n();
const localPath = useLocalePath();
useFaqSeoMeta("faq.tab13.title1", "faq.tab13.text3");
</script>
